(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avant-apres"] && !Shopify.designMode) return;
  try {
    
  // Charger Cocoen.js si pas déjà chargé
  if (!window.CocoenLoaded) {
    var cocoenScript = document.createElement('script');
    cocoenScript.src = 'https://cdn.jsdelivr.net/npm/cocoen@2.0.5/dist/cocoen.min.js';
    cocoenScript.onload = function () {
      document.querySelectorAll('.cocoen').forEach(function (el) {
        new Cocoen(el);
      });
    };
    document.head.appendChild(cocoenScript);
    window.CocoenLoaded = true;
  } else {
    document.querySelectorAll('.cocoen').forEach(function (el) {
      new Cocoen(el);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mainir-header"]) return;
  try {
    
document.addEventListener('cart:update', (event) => {
  const data = event.detail?.data;
  const count = event.detail?.resource?.item_count;
  const counter = document.querySelector('[data-mainir-cart] span');
  if (counter && Number.isInteger(count)) counter.textContent = String(count);
  if (data?.source !== 'product-form-component' || data.didError) return;
  const cartLink = document.querySelector('[data-mainir-cart]');
  if (cartLink) window.location.assign(cartLink.href);
});

  } catch(e) { console.error(e); }
})();
})();
